 import React, { useEffect, useState, useContext, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { CardOrdensDeServico } from "../../../components/CardOrdensDeServico";
import { CardAtividadesOptions } from "../../../components/CardAtividadesOptions";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { IconRefresh } from "../../../svg";
import { ToggleSwitch } from "../../../components/ToggleSwitch";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { useForm } from 'react-hook-form';
import { PaginationCustom } from "../../../components/PaginationCustom";
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getStatusList } from '../../../services/status';
import { getClients } from '../../../services/clientes';
import { getEmpresas } from '../../../services/empresas';
import { ModalOrdenDeServico } from "../../../components/ModalOrdenDeServico";
import { ModalOrdenDeServicoEdicao } from "../../../components/ModalOrdenDeServicoEdicao";
import { ModalObservacao } from "../../../components/ModalObservacao";
import { ModalTimeline } from "../../../components/ModalTimeline";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";

const advanceSearch = { name: 'advanceSeach', label: 'Pesquisa Avançada', id: 'advanceSeachAP' };

const getLista = async (formValues = null, currentPage = 0, pageSize) => {
    let list = null;

    let params = `Start=${currentPage}&Length=${pageSize}`;

    if (formValues.search != null && formValues.search != 0) {
        params += `&Search=${formValues.search}`;
    }

    if (formValues.data?.Segurado?.length > 0) {
        params += `&Segurado=${formValues.data.Segurado}`;
    }

    if (formValues.data?.Sigla?.length > 0) {
        params += `&Sigla=${formValues.data.Sigla}`;
    }

    if (formValues.data?.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.data.NumeroTimesheet}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idStatus > 0) {
        params += `&Status=${formValues.idStatus}`;
    }

    if (formValues.startDate) {
        var inicio = moment(formValues.startDate).format('YYYY-MM-DD')
        inicio += " 00:00"
        params += `&PeriodoInicial=${inicio}`;
    }

    if (formValues.endDate) {
        var final = moment(formValues.endDate).format('YYYY-MM-DD')
        final += " 23:59:59"
        params += `&PeriodoFinal=${final}`;
    }

    if (formValues.idEmpresa > 0) {
        params += `&IdEmpresa=${formValues.idEmpresa}`;
    }

    try {
        const response = await api.get(`OrdemDeServico/list?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

const getListaTS = async (formValues = null, currentPage = 0, pageSize) => {
    let list = null;

    let params = `Start=${currentPage}&Length=${pageSize}`;

    if (formValues.search != null && formValues.search != 0) {
        params += `&Search=${formValues.search}`;
    }

    if (formValues.data?.Segurado?.length > 0) {
        params += `&Segurado=${formValues.data.Segurado}`;
    }

    if (formValues.data?.Sigla?.length > 0) {
        params += `&Sigla=${formValues.data.Sigla}`;
    }

    if (formValues.data?.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.data.NumeroTimesheet}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idStatus > 0) {
        params += `&Status=${formValues.idStatus}`;
    }

    if (formValues.startDate) {
        var inicio = moment(formValues.startDate).format('YYYY-MM-DD')
        inicio += " 00:00"
        params += `&PeriodoInicial=${inicio}`;
    }

    if (formValues.endDate) {
        var final = moment(formValues.endDate).format('YYYY-MM-DD')
        final += " 23:59:59"
        params += `&PeriodoFinal=${final}`;
    }

    if (formValues.idEmpresa > 0) {
        params += `&IdEmpresa=${formValues.idEmpresa}`;
    }

    try {
        const response = await api.get(`OrdemDeServico/timesheets/pendentes?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const OrdensDeServico = () => {
    const [showAdvanceSearch, setAdvanceSearch] = useState(false);
    const [ListaData, setListaData] = useState(null);
    const [ListaDataTs, setListaDataTs] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentPageTS, setCurrentPageTS] = useState(0);
    const { register, handleSubmit, reset } = useForm();
    const [clientList, setClientList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [empresaList, setEmpresaList] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizeTS, setPageSizeTS] = useState(10);
    var [loadingData, setLoadingData] = useState(true);
    var [idStatus, setStatusId] = useState(1);
    var [idEmpresa, setEmpresaId] = useState([]);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    var [status, setStatus] = useState("Gerado");
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    const [modalObservacoes, setmodalObservacoes] = useState(false);
    const [selectedIdTimesheet, setSelectedIdTimesheet] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;

    var [searchInput, setSearchInput] = useState(null);
    const [selectedOrdemDeServico, setSelectedOrdemDeServico] = useState(false);

    const formSubmit = async (data) => {
        setLoadingData(true)
        Promise.all([loadTable(data, 0, 10), loadTableTS(data, 0, 10)]).then((values) => {
            setLoadingData(false)
        })
            .catch(error => {
                setLoadingData(false)
            });
    }

    const loadTable = async (data, currentPage, pageSize) => {
        let formValues = {
            data: data,
            search: 0,
            idCliente: idCliente,
            idStatus: idStatus,
            idEmpresa: idEmpresa,
            startDate: startDate,
            endDate: endDate
        };
        setListaData(null);
        const lista = await getLista(formValues, currentPage, pageSize);
        setListaData(lista);
        if (lista != null && lista?.data?.itens?.length > 0) {
            pageSize = lista.data.page.recordsPaging;
            setPageSize(pageSize);
        }
    }

    const loadTableTS = async (data, currentPageTS, pageSize) => {
        let formValues = {
            data: data,
            search: 0,
            idCliente: idCliente,
            idStatus: idStatus,
            idEmpresa: idEmpresa,
            startDate: startDate,
            endDate: endDate
        };
        setListaDataTs(null);
        const lista = await getListaTS(formValues, currentPageTS, pageSize);
        setListaDataTs(lista);
        if (lista != null && lista?.data?.itens?.length > 0) {
            pageSize = lista.data.page.recordsPaging;
            setPageSizeTS(pageSize);
        }
    }

    const getStatusToggle = (status) => {
        setAdvanceSearch(status);
        setSearchReadOnly(status);
        searchReadOnly = status;
    };

    const getSearch = async (currentValue, value) => {
        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            Contato: null,
            Endereco: null
        }

        let formValues = {
            data: data,
            search: (currentValue?.length >= 3) ? currentValue : null,
            idCliente: null,
            idEmpresa: idEmpresa,
            idStatus: null,
            startDate: null,
            endDate: null
        };

        Promise.all([loadTable(formValues, 0, pageSize), loadTableTS(formValues, 0, pageSizeTS)]).then((values) => {
            setLoadingData(false)
        }).catch(error => {
            setLoadingData(false)
        });
        setSearchInput((currentValue?.length >= 3) ? currentValue : null)

    };

    const refreshData = async () => {
        let data = {
            IdentificaoSolicitacao: null,
            Segurado: null,
            Contato: null,
            Endereco: null
        }

        let formValues = {
            data: data,
            search: (searchInput?.length >= 3) ? searchInput : '',
            idCliente: idCliente,
            idStatus: idStatus,
            startDate: startDate,
            endDate: endDate
        };

        Promise.all([loadTable(formValues, 0, pageSize), loadTableTS(formValues, 0, pageSizeTS)]).then((values) => {
            setLoadingData(false)
        }).catch(error => {
            setLoadingData(false)
        });
    }

    const getCliente = (currentValue, value) => {

        if (value === "clear" || value === null) {
            setCliente(null);
            setIdCliente(null);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });

        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getStatus = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setStatus(null);
            setStatusId(null);
            return;
        }

        var statusResult = statusList.filter(function (o) {
            return o.key == value;
        });

        status = statusResult[0].value;
        idStatus = statusResult[0].key;
        setStatus(status);
        setStatusId(idStatus);

    };

    const getEmpresa = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setEmpresaId(null);
            return;
        }

        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        status = statusResult[0].description;
        idStatus = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setEmpresaId(idStatus);
    };

    const getCardId = (id) => {
        let cardId = document.getElementById(id);

        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };

    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);
            }

            const statusList = await getStatusList(48);
            if (!!statusList) {
                setStatusList(statusList)
            }

            const empresaList = await getEmpresas();
            if (!!empresaList) {
                setEmpresaList(empresaList)
            }
        }
        asyncFn().then(async (response) => {
            setLoadingData(true)
            Promise.all([loadTable(null, 0, 10), loadTableTS(null, 0, 10)]).then((values) => {
                setLoadingData(false)
            })
                .catch(error => {
                    setLoadingData(false)
                });
        })
    }, [null, 0, 10]);

    const submitButtonRef = useRef(null)

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const limparPesquisa = () => {
        reset({
            IdentificaoSolicitacao: '',
            Segurado: '',
            Contato: '',
            Endereco: ''
        });
        setCliente(null);
        setStatus(null);
    }

    const openModal = () => {
        setmodalOrdenServico(true);
    };

    const openModalEdicao = (item) => {
        setSelectedOrdemDeServico(item);
        setmodalOrdenServicoEdicao(true);
    };

    const [modalOrdenServico, setmodalOrdenServico] = useState(false);
    const closemodalOrdenServico = () => {
        setmodalOrdenServico(false);
    }

    const [modalOrdenServicoEdicao, setmodalOrdenServicoEdicao] = useState(false);
    const closemodalOrdenServicoEdicao = () => {
        setmodalOrdenServicoEdicao(false);
    }

    const openObservacoesTimesheet = (idTimesheet) => {
        setSelectedIdTimesheet(idTimesheet)
        openModalObservacoesOpen()
    }

    const openModalObservacoesOpen = () => {
        setmodalObservacoes(true);
    };

    const closeModalObservacoes = () => {
        setmodalObservacoes(false);
    }

    const afterNotifyGrupoOpenModal = () => { };

    const [modalTimelineIsOpen, setmodalTimelineIsOpen] = useState(false);
    const [selectedTimesheet, setSelectedTimesheet] = useState(null);
    const openModalTimesheetTimeline = (timesheet) => {
        setSelectedTimesheet(timesheet)
        setmodalTimelineIsOpen(true)
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header m-0">Ordens de Serviço - OMIE</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                        <input className='default-button-red' value='Adicionar' type="button" onClick={openModal} />
                    </div>
                    <div className="card">
                        <div className="row">
                            <div className="col-sm-12 col-md-3 col-lg-3 col-xxl-3 my-1-mobile">
                                <DynamicInput placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} />
                            </div>
                            <div className="d-flex flex-column justify-content-center justify-content-center col-sm-12 col-md-3 col-lg-3 col-xxl-2">
                                <ToggleSwitch config={advanceSearch} setStatus={(status) => getStatusToggle(status)} />
                            </div>
                        </div>
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className={!!showAdvanceSearch ? `form-wrapper filter-container mt-3` : `form-wrapper filter-container filter-hide`}>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={selectedEmpresa}
                                        label={'Selecione a empresa'}
                                        name={'idEmpresa'}
                                        options={empresaList}
                                        keyValue={'idEmpresa'}
                                        keyLabel={'description'}
                                        paramMethod={getEmpresa}
                                        clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={cliente} label={'Selecione o cliente'} name={'idCliente'} options={clientList} keyValue={'idCliente'} keyLabel={'cliente'} paramMethod={getCliente} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <DynamicSelect placeholder={''} valuetext={status} label={'Status'} name={'idAtividade'} options={statusList} keyValue={'key'} keyLabel={'value'} paramMethod={getStatus} clearOption={true} />
                                </div>
                                <div className="position-relative col-sm-6 col-md-6 col-lg-6 p-2">
                                    <div className="position-relative form-group col-sm-12 col-md-5 col-lg-5" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            placeholderText={'Data de início'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-5 col-lg-5" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            placeholderText={'Data fim'}
                                            customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                        />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' ref={submitButtonRef} />
                                </div>
                            </div>
                        </StyledForm>

                        {loadingData ?
                            <StldRow>
                                <div className="text-center">
                                    <div className="align-items-center">
                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                        <div><strong style={{ color: "#EE4B21" }}>{'Atualizando...'}</strong></div>
                                    </div>
                                </div>
                            </StldRow > :
                            <Tabs className="timesheet">
                                <TabList>
                                    <Tab>OS criadas</Tab>
                                    <Tab>TS a integrar <span className="badge badge-primary">{ListaDataTs?.data?.page?.recordsTotal || 0}</span></Tab>
                                </TabList>
                                <TabPanel>
                                    <div>
                                        <StldRow>
                                            {
                                                ListaData != null && ListaData?.data?.itens?.map((item, index) => {
                                                    return (
                                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="4" xl="4">
                                                            <CardOrdensDeServico
                                                                item={item}
                                                                getCardId={getCardId}
                                                                index={index}
                                                                openModalEdicao={(item) => openModalEdicao(item)}
                                                                loadOrdens={() => formSubmit(null, 0, 10)}
                                                            />
                                                        </StldColumn>
                                                    )
                                                })
                                            }
                                            {
                                                ListaData?.data?.itens.length == 0 && <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado!
                                                    </div>
                                                </StldColumn>
                                            }
                                        </StldRow>
                                        {
                                            (() => {
                                                if (ListaData != null) {
                                                    return (
                                                        <PaginationCustom isMobile={isMobile}
                                                            isDesktop={isDesktop}
                                                            length={ListaData.data.page.length}
                                                            recordsTotal={ListaData?.data?.page?.recordsTotal ?? 0}
                                                            currentPage={currentPage}
                                                            formData={loadTable}
                                                            pageSize={pageSize ?? 10}
                                                            setPageSize={setPageSize}
                                                            setPage={(page) => setCurrentPage(page)} />
                                                    )
                                                }
                                                return null
                                            })()
                                        }
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div>
                                        <StldRow>
                                            {
                                                ListaDataTs != null && ListaDataTs?.data?.itens?.map((item, index) => {
                                                    return (
                                                        <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                            <CardAtividadesOptions
                                                                item={item}
                                                                getCardId={getCardId}
                                                                openObservacoesTimesheet={openObservacoesTimesheet}
                                                                openModalTimesheetTimeline={openModalTimesheetTimeline}
                                                            />
                                                        </StldColumn>
                                                    )
                                                })
                                            }
                                            {
                                                ListaDataTs?.data?.itens.length == 0 && <StldColumn xs="12" sm="12" md="12">
                                                    <div className="alert alert-warning" role="alert">
                                                        Atenção! Nenhum resultado encontrado!
                                                    </div>
                                                </StldColumn>
                                            }
                                        </StldRow>
                                        {
                                            (() => {
                                                if (ListaDataTs != null) {
                                                    return (
                                                        <PaginationCustom isMobile={isMobile}
                                                            isDesktop={isDesktop}
                                                            length={ListaDataTs.data.page.length}
                                                            recordsTotal={ListaDataTs?.data?.page?.recordsTotal ?? 0}
                                                            currentPage={currentPage}
                                                            formData={loadTable}
                                                            pageSize={pageSizeTS ?? 10}
                                                            setPageSize={setPageSizeTS}
                                                            setPage={(page) => setCurrentPageTS(page)} />
                                                    )
                                                }
                                                return null
                                            })()
                                        }
                                    </div>
                                </TabPanel>
                            </Tabs>}
                    </div>
                    <br />
                </StyledDefaultPage>
                <ModalOrdenDeServico
                    isOpen={modalOrdenServico}
                    onRequestClose={closemodalOrdenServico}
                    ariaHideApp={false}
                    empresaList={empresaList}
                    clientList={clientList}
                    loadOrdens={() => formSubmit(null, 0, 10)}
                >
                </ModalOrdenDeServico>
                <ModalOrdenDeServicoEdicao
                    isOpen={modalOrdenServicoEdicao}
                    onRequestClose={closemodalOrdenServicoEdicao}
                    ariaHideApp={false}
                    empresaList={empresaList}
                    clientList={clientList}
                    loadOrdens={() => formSubmit(null, 0, 10)}
                    selectedOrdemDeServico={selectedOrdemDeServico}
                >
                </ModalOrdenDeServicoEdicao>
                <ModalObservacao
                    isOpen={modalObservacoes}
                    onAfterOpen={afterNotifyGrupoOpenModal}
                    onRequestClose={closeModalObservacoes}
                    idTimesheet={selectedIdTimesheet}
                >
                </ModalObservacao>
                <ModalTimeline
                    isOpen={modalTimelineIsOpen}
                    setIsOpen={setmodalTimelineIsOpen}
                    onRequestClose={() => setmodalTimelineIsOpen(false)}
                    idTimesheet={selectedTimesheet?.idTimesheet}
                    timelineInfs={[
                        {
                            label: "Data do Sinistro",
                            value: selectedTimesheet?.dataSinistro || "Não informado"
                        },
                        {
                            label: "Data de abertura do Sinistro",
                            value: selectedTimesheet?.dataAbertura
                        },
                        {
                            label: "Data de abertura do TS",
                            value: selectedTimesheet?.dataTimesheet
                        }
                    ]}
                    porEtapaAprovacao={selectedTimesheet?.slaPorEtapa}
                    finalizacaoTS={selectedTimesheet?.dataFinalizacaoTS}
                    nomeEtapaAtual={selectedTimesheet?.nomeEtapa}
                >
                </ModalTimeline>
            </main >

        </section >
    );
};

export const OrdensDeServicoPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <OrdensDeServico />

                </>
            )}
        </>
    );
};
